import EditStatusPage from './EditStatusPage';

export default EditStatusPage;
